import { SidebarProvider, useSidebar } from '@/app/providers/SidebarProvider';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import AppHeader from './AppHeader';
import Backdrop from './Backdrop';
import AppSidebar from './AppSidebar';
import { PageContainer } from '@/shared/components/PageContainer';
import { useIsFullWidthPage } from './pageLayout';

interface AppLayoutProps {
    children?: React.ReactNode;
}

const LayoutContent: React.FC<AppLayoutProps> = ({ children }) => {
    const { isExpanded, isHovered, isMobileOpen } = useSidebar();
    const isFullWidthPage = useIsFullWidthPage();
    const content = children || <Outlet />;

    return (
        <div className="min-h-[calc(100vh-var(--env-banner-height))] xl:flex">
            <div>
                <AppSidebar />
                <Backdrop />
            </div>
            <div
                className={`flex-1 transition-all duration-300 ease-in-out ${
                    isExpanded || isHovered ? 'lg:ml-[290px]' : 'lg:ml-[90px]'
                } ${isMobileOpen ? 'ml-0' : ''}`}
            >
                <AppHeader />
                {isFullWidthPage ? content : <PageContainer>{content}</PageContainer>}
            </div>
            <ToastContainer position="bottom-right" style={{ zIndex: 999999 }} />
        </div>
    );
};

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    return (
        <SidebarProvider>
            <LayoutContent>{children}</LayoutContent>
        </SidebarProvider>
    );
};
